import React, { useState, useContext } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { getOpenTier } from '../../summit-program/summit';
import { UserContext } from '../WithUserState/WithUserState';
import styles from './BuyButton.css';
import BuyModal from '../BuyModal/BuyModal';
import ETFBuyModal from '../ETFBuyModal/ETFBuyModal';

const BuyButton = ({
    ticker,
    open,
    buyRestricted,
    blue,
    content,
    children,
    closedContent,
    loud,
    loggedIn,
    funds,
    userStateLoaded,
    fundName = '',
    etf
}) => {
    const { summitTier, summitTierLoaded } = useContext(UserContext) || {};
    const isOpenTier = getOpenTier(summitTier);

    const [openModal, setOpenModal] = useState(false);
    const btnContent = children || content;
    const textBtn = typeof btnContent === 'string';

    if (!open && !summitTierLoaded) {
        return <div className="summit-loading">Loading...</div>;
    }

    return (
        <React.Fragment>
            {(open || isOpenTier) && !buyRestricted ? (
                <button
                    className={cn({ loud, blue, 'text-button': textBtn })}
                    id={`buy-btn-${ticker}`}
                    onClick={() => setOpenModal(true)}
                    type="button"
                >
                    {btnContent}
                </button>
            ) : (
                <button
                    className={cn('closed', {
                        loud,
                        'text-button': textBtn
                    })}
                    disabled
                    type="button"
                >
                    {closedContent}
                </button>
            )}
            <style jsx>{styles}</style>

            {openModal && !etf
                ? ReactDOM.createPortal(
                      <BuyModal
                          open={openModal}
                          ticker={ticker}
                          fundName={fundName}
                          funds={funds}
                          fundIsOpen={open || isOpenTier}
                          openToNewInvestors={open}
                          onClose={() => setOpenModal(false)}
                          loggedIn={loggedIn}
                          userStateLoaded={userStateLoaded}
                      />,
                      document.body
                  )
                : ReactDOM.createPortal(
                      <ETFBuyModal
                          open={openModal}
                          onClose={() => setOpenModal(false)}
                          loggedIn={loggedIn}
                          userStateLoaded={userStateLoaded}
                      />,
                      document.body
                  )}
        </React.Fragment>
    );
};

BuyButton.defaultProps = {
    content: 'Buy',
    closedContent: 'Closed',
    open: false,
    loud: false,
    blue: false
};

BuyButton.propTypes = {
    ticker: PropTypes.string.isRequired,
    open: PropTypes.bool,
    loud: PropTypes.bool,
    blue: PropTypes.bool,
    content: PropTypes.node,
    closedContent: PropTypes.node
};

export default BuyButton;
